module.exports = __webpack_public_path__ + "img/status_preparing_head.55dd5e59.png";